import React from 'react'

const LinkedinPosts = () => {
  return (
    <div class='sk-ww-linkedin-page-post' data-embed-id='25397448'></div>
  )
}

export default LinkedinPosts